module.exports = __webpack_public_path__ + "static/img/1.2b9145b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/sp/1.png
// module id = eOvS
// module chunks = 0